module.exports = __webpack_public_path__ + "media/6.3e499e65.mp3";